import { render, staticRenderFns } from "./OrylSticky.vue?vue&type=template&id=25719d83&"
import script from "./OrylSticky.vue?vue&type=script&lang=js&"
export * from "./OrylSticky.vue?vue&type=script&lang=js&"
import style0 from "./OrylSticky.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
installComponents(component, {VBanner})
